import{a as e}from"./chunk-KERBADJJ.js";import{n as o,o as r}from"./chunk-YQYVFZYE.js";var f=new o({locale:[e,r]});export{f as a};
